import store from '../store/index.js';
import _ from 'lodash';

const endsWith = (str, suffix) => {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
};

const isInternalUser = (user) => {
  return (
    user?.impersonated || //impersonate
    _.includes(user?.roles, 'previewer') || //previewers
    _.includes(user?.roles, 'admin') || //admin
    (user.email &&
      _.some(['iangels.co', 'iangels.com', 'icapital.io', '21mcapital.com'], function (domain) {
        return endsWith(user.email, domain);
      }))
  );
};

const isTestUser = (user) => {
  return (
    (user.email &&
      _.some(['mailinator.com'], function (domain) {
        return endsWith(user.email, domain);
      })) ||
    (user.name && user.name.match(new RegExp('\\btest\\b')) !== null)
  ); //test users
};

const isProductionEnv = () => {
  return process.env.REACT_APP_BUILD_ENV === 'production';
};

const bypass = (user) => {
  if (!isProductionEnv()) {
    return false;
  }

  return isInternalUser(user) || isTestUser(user);
};

const getVirtualPath = () => {
  const path = window.location.hash;
  const absUrl = window.location.href;

  return absUrl.substring(absUrl.indexOf(path));
};

export const init = () => {
  if (!isProductionEnv()) {
    window.analytics.debug();
  }
  if (!window.Intercom) {
    return;
  }

  window.Intercom('update');

  window.Intercom('onActivatorClick', function () {
    track('Intercom got activated');
  });

  window.Intercom('onShow', function () {
    track('Intercom on Show');
  });

  window.Intercom('onHide', function () {
    track('Intercom on Hide');
  });
};

export const identify = (isUpdate) => {
  const state = store.getState();
  const profile = state?.auth?.user;
  const authResult = state?.auth?.authResult;
  if (bypass(profile)) {
    return;
  }
  const userId = profile?.user_id || profile?.sub || authResult?.user_id || authResult?.sub;
  const traits = state?.auth?.traits;
  const visits = profile?.visits ?? traits?.visits ?? 1;

  if (!userId) {
    return;
  }

  const superProps = {
    platform: 'iAngels',
    user_id: String(userId),
    email: profile?.email || traits?.email || '',
    email_verified: profile?.email_verified ?? traits?.email_verified,
    name: profile?.user_metadata?.full_name || profile?.name || traits?.full_name || traits?.fullName || '',
    country: profile?.user_metadata?.country ?? '',
    city: profile?.user_metadata?.city ?? '',
    applications: profile?.applications,
    visits: visits,
    roles: profile?.app_metadata?.roles || profile?.roles || traits?.roles,
    owner: profile?.app_metadata?.account_owner ?? '',
    referrer: profile?.app_metadata?.referrer ?? '',
    accreditation: profile?.app_metadata?.level || traits?.level || '',
    icapital_accreditation: profile?.app_metadata?.icapital_level ?? '',
    date_registered: profile?.app_metadata?.date_registered,
    icapital_date_registered: profile?.app_metadata?.icapital_date_registered,
    investments: profile?.app_metadata?.investments,
    icapital_investments: profile?.app_metadata?.icapital_investments,
    has_portfolio: profile?.app_metadata?.has_portfolio,
    user_status: profile?.app_metadata?.user_status ?? traits?.user_status ?? '',
    icapital_user_status: profile?.app_metadata?.icapital_user_status ?? '',
    access_limitations: profile?.app_metadata?.access_limitations,
  };

  if (profile) {
    try {
      const sanitizedProps = _.omitBy(superProps, (v) => v == null);
      if (!isUpdate && visits === 1) {
        window.analytics.alias(userId);
      }
      window.analytics.identify(userId, sanitizedProps);
    } catch (err) {
      console.error('Analytics identify error:', err);
    }
  }
};

export const pageView = (name, url, traits) => {
  if (!name) return;
  const profile = store.getState()?.auth?.user;
  if (bypass(profile)) {
    return;
  }
  try {
    var virtualUrl = getVirtualPath();
    window.analytics.page(
      name,
      _.extend(
        {
          url: url || virtualUrl,
        },
        traits || {}
      )
    );
  } catch (err) {
    console.error('Analytics pageView error:', err);
  }
};

export const track = (event, data = {}) => {
  try {
    const state = store.getState();
    const user = state?.auth?.user;

    const _data = _.extend({}, data, {
      url: window.location.hash,
      user_email: user?.email ?? '',
      authenticated: user !== null,
      registered: true,
    });
    window.analytics.track(event, _data);
  } catch (err) {
    console.error('Analytics track error:', err);
  }
};

export const time = (event) => {
  try {
    window.mixpanel && window.mixpanel.time_event(event);
  } catch (err) {
    console.error('Analytics time_event error:', err);
  }
};

export const isValideReport = () => {
  const state = store.getState();
  const user = state?.auth?.user;
  return isProductionEnv() && !isInternalUser(user) && !isTestUser(user);
};
